import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getApiBaseURL } from "../utils/api";
import axios from "axios";

const ResetPassword = () => {
  const { user_id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    password: "",
    confirm_password: "",
  });
  const [message, setMessage] = useState("");
  const apiBase = getApiBaseURL();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirm_password) {
      return setMessage("❌ Passwords do not match.");
    }

    try {
      await axios.post(`${apiBase}/api/auth/reset-password`, {
        user_id,
        password: formData.password,
      });

      setMessage("✅ Password reset successfully. Redirecting to login...");
      setTimeout(() => navigate("/"), 2000);
    } catch (err) {
      console.error("❌ Error resetting password:", err);
      setMessage("❌ Failed to reset password.");
    }
  };

  return (
    <div className="container mt-5">
      <h2>Reset Your Password</h2>
      {message && <p className="fw-bold">{message}</p>}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>New Password</label>
          <input
            type="password"
            name="password"
            className="form-control"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label>Confirm Password</label>
          <input
            type="password"
            name="confirm_password"
            className="form-control"
            value={formData.confirm_password}
            onChange={handleChange}
            required
          />
        </div>
        <button className="btn btn-primary">Reset Password</button>
      </form>
    </div>
  );
};

export default ResetPassword;
